// extracted by mini-css-extract-plugin
module.exports = {"comments":"bb_fg","comments__list":"bb_fh"};